export default __webpack_public_path__ + "static/media/Employers-2.aece84c1.svg";